import sum from 'lodash/sum';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { createSlice, Dispatch } from '@reduxjs/toolkit';

import { IOrganizationState } from 'src/@types/organization';

// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState: IOrganizationState = {
  isLoading: false,
  error: null,
  organizations: [],
  organization: null,
};

const slice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Organizations
    getOrganizationsSuccess(state, action) {
      state.isLoading = false;
      state.organizations = action.payload.content;
    },

    // GET ORGANIZATION
    getOrganizationSuccess(state, action) {
      state.isLoading = false;
      state.organization = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;


// ----------------------------------------------------------------------

export function getOrganizations(page:number) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/v1/organizations/parents?page=${page}&size=10`);
      // name , price, category, status, image
      // detail : +descreption (+ addons)
      dispatch(slice.actions.getOrganizationsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getOrganization(id: string) {
  return async (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/v1/organizations/${id}`);
      dispatch(slice.actions.getOrganizationSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
